import React from "react";
import { render } from "react-dom";
import PublicWrapper from "./layouts/PublicWrapper";
import ForgotPasswordContainer from "./components/login/forgotPasswordContainer";
import { FORGOT_PASSWORD, forgotPassword } from "./components/login/forgotPassword-redux";

require("../less/app.less");

render(
    <PublicWrapper reducers={{ [FORGOT_PASSWORD]: forgotPassword }}>
        <ForgotPasswordContainer />
    </PublicWrapper>,
    document.getElementById("forgotPassword")
);
